import * as ns from './ns.js';

function addZignalyUiResources(i18nInstance) {
    i18nInstance.on("loaded", function () {
        Object.entries(ns).forEach(function (_a) {
            var l = _a[0], v = _a[1];
            return i18nInstance.addResourceBundle(l, "zignaly-ui", v);
        });
    });
}
var zignalyUiI18nAllTranslations = ns;

export { addZignalyUiResources, zignalyUiI18nAllTranslations };
